import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useVideos } from './VideoStore';
import VideoUpload from '../../../Components/Macro/ImgUpload/VideoUpload';
import { useVideoCat } from '../VideoCat/VideoCatState';

function Add() {
    const formRef = useRef();
    let { addVideo } = useVideos()
    let { cats, setCats } = useVideoCat()
    let [videoUrl, setVideoUrl] = useState('')
    
    useEffect(() => {
        setCats();
    }, [])
    
    const handleFinish = (values) => {
        let data = {
            ...values,
            url: videoUrl
        }
        addVideo(data);
        formRef.current?.resetFields();
        setVideoUrl('');
    }
    
    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
                autoComplete="off"
            >
                <Form.Item
                    label="Video nomi"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: "To'ldirish majburiy",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Videoni yuklash"
                    name="url"
                >
                    <VideoUpload setVideo={setVideoUrl} />
                </Form.Item>
                <Form.Item
                    label="Kategoriyasi"
                    name="cat_id"
                >
                    <Select>
                        {cats.map((item) => (
                            <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Saqlash
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Add;